<section>
  <div>
    <div class="inner-wrap">
      <p class="text-center">
        <img src="assets/modules/dummy-assets/common/img/GovEVA.png" alt="DigiCompany">
      </p>
      <h2>LOGIN WITH OTP</h2>
      <form autocomplete="off" [formGroup]="loginForm">
        <div class="form-group">
          <label>Mobile Number:</label>
          <input [(ngModel)]="mobileNumber" class="form-control" type="text" formControlName="mobileNumber" max="10" min="10">
          <div *ngIf="loginForm.controls['mobileNumber'].hasError('required') && loginForm.controls['mobileNumber'].touched" class="form-control-error-custom">
            Mobile Number is required
          </div>
          <div *ngIf="loginForm.controls['mobileNumber'].hasError('pattern') && !loginForm.controls['mobileNumber'].hasError('required')" class="form-control-error-custom">
            Please enter valid mobile Number
          </div>
        </div>
        
        <div class="form-group">
          <label>E-mail address / Username:</label>
          <input [(ngModel)]="userName" (ngModelChange)="getCompaniesByEmailId()" class="form-control" type="text" formControlName="userName">
          <div *ngIf="loginForm.controls['userName'].hasError('required') && loginForm.controls['userName'].touched" class="form-control-error-custom">
            Email / Username is required.
          </div>
        </div>
        
        <div class="form-group">
          <label>Select your company:</label>
          <div class="below" style="border:0"></div>
          <ng-select [notFoundMsg]="isEmailForCompany" [(ngModel)]="selectedCompanyId"
            bindLabel="label" bindValue="value"
            (change)="companySelection(selectedCompanyId)" class="companyddl" [multiple]=false [items]="companyList"
            [formControl]="loginForm.controls['companyName']" style="text-align:left;">
          </ng-select>
          <div
            *ngIf="loginForm.controls['companyName'].hasError('required') && loginForm.controls['companyName'].touched && companyList && companyList.length"
            class="form-control-error-custom">
            Company Name is required.
          </div>
        </div>

        <div class="forgot-password-wrapper">
          <a class="forgot-password-link" [routerLink]="['/login']">Back to Sign In</a>
        </div>
        <div class="clearfix"></div>
        
        <div class="text-center">
          <button class="btn btn-primary btn-block mr-2 mb-2" style="margin-top: 10px;" 
            [disabled]="!loginForm.valid" 
            (click)="sendOTP()">
            <i aria-hidden="true"></i>Login with OTP
          </button>
        </div>
      </form>
    </div>
  </div>
</section>
